import styled from "styled-components"

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 0 1.5rem;
`
